import jQuery from 'jquery';

const $ = jQuery;

import useragent from './modules/useragent';

import smoothscroll from './modules/smoothscroll';

import site from './modules/site';

import menu from './modules/menu';

import slider from './modules/slider';

import drop from './modules/drop';

import tab from './modules/tab';

/* import map from './modules/map'; */



